import { Button, Tooltip } from '@mantine/core';
import { FC } from 'react';

import { CardStatus } from '@/models/CardStatus.ts';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    status: CardStatus;
    onClick?: () => void;
}

const CardButton: FC<Props> = ({ status, onClick }) => {
    const statusStyles = {
        [CardStatus.READ]: {
            indicator: 'bg-emerald-500 shadow-emerald-500/50',
            border: 'border-emerald-200 hover:border-emerald-300',
            bg: 'bg-emerald-50/50 hover:bg-emerald-50',
        },
        [CardStatus.UNREAD]: {
            indicator: 'bg-rose-500 shadow-rose-500/50',
            border: 'border-rose-200 hover:border-rose-300',
            bg: 'bg-rose-50/50 hover:bg-rose-50',
        },
        [CardStatus.NOT_APPLICABLE]: {
            indicator: 'bg-slate-400 shadow-slate-400/50',
            border: 'border-slate-200 hover:border-slate-300',
            bg: 'bg-slate-50/50 hover:bg-slate-50',
        },
    };

    const statusMessage = {
        [CardStatus.READ]: 'eGK wurde erfolgreich eingelesen',
        [CardStatus.UNREAD]: 'eGK muss noch eingelesen werden',
        [CardStatus.NOT_APPLICABLE]: 'eGK-Einlesen nicht erforderlich',
    };

    const currentStyles = statusStyles[status];

    return (
        <Tooltip label={statusMessage[status]}>
            <Button
                leftSection={
                    <div className={cn('size-2.5 min-w-2.5 rounded-full shadow-sm', currentStyles.indicator)} />
                }
                variant="default"
                onClick={onClick}
                className={cn(
                    'font-medium text-slate-900 transition-all duration-150',
                    'border shadow-sm hover:shadow',
                    currentStyles.border,
                    currentStyles.bg
                )}
            >
                eGK lesen
            </Button>
        </Tooltip>
    );
};

export default CardButton;
